<template>
  <EditCom
    title="线索区数据保存"
    :target="editTarget"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import EditCom from '@/components/EditCom'

import { addExposure, } from '@/api/ExposureApi';

// props
const props = defineProps({
  data: { type: Array, },
  layer: { type: Object, },
});
// emit
const emit = defineEmits([
  'close',
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});
const close = ()=>{
  emit('close');
}

const editTarget = reactive({
  name: '',
  dataList: props.data && props.data.map(e=> e['exposureList']).flat(),
  startTime: props.data && props.data.at(0) && props.data.at(0)['exposureTime'],
  endTime: props.data && props.data.at(-1) && props.data.at(-1)['exposureTime'],
})

console.log(editTarget);

const submitFn = (item, button, loadFn, fn)=>{
  // console.log(item);
  const json = props.layer && props.layer.toGeoJSON(),
        geom = JSON.stringify(json);
  const mapId = store.getters['workBenchMapId'];
  addExposure({
    ...item,
    geom,
    mapId,
  }).then(res=>{
    if(res.data.code == 1004){
      message(res.data.msg, 1);
      close();
    }
  }).catch(err=>{
    console.log(err);
  }).finally(()=>{
    loadFn && loadFn();
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '名称', prop: 'name', type: 'text' },
]);
const rules = reactive({
  name: [
    { required: true, message: '请输入名称', trigger: 'blur' },
  ],
});
</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>